import React from "react";
import { useTheme } from "@/lib/theme";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ className = "" }) {
    const { theme, toggle } = useTheme();
    const isDark = theme === "dark";
    return (
        <button
            type="button"
            onClick={toggle}
            aria-label={isDark ? "Activer le mode jour" : "Activer le mode nuit"}
            data-testid="theme-toggle"
            className={`theme-toggle ${className}`}
        >
            <span className="knob">
                {isDark
                    ? <Moon size={11} strokeWidth={1.6} />
                    : <Sun size={11} strokeWidth={1.6} />}
            </span>
        </button>
    );
}
